import request from "@/utils/request";
import { addUrlPerFix } from "@/utils";
// 获取采购计划编制列表数据
export function queryPurchasePlanList(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_LS_URL) +
      "/apis/sclma/ppc/plan/queryPurchasePlanList",
    method: "post",
    data
  });
}
//按计划询价-根据计划id-查询物资以及物资对应的商品列表
export function queryPlanMatSpuPage(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_EMPO_URL) +
      "/apis/empo/spc/planSeek/queryPlanMatSpuPage",
    method: "post",
    data
  });
}
//立即询价
export function checkAvailNumByPlanId(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_EMPO_URL) +
      "/apis/empo/spc/planSeek/checkAvailNumByPlanId",
    method: "post",
    data
  });
}
export function savePlanMatSkuTmp(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_EMPO_URL) +
      "/apis/empo/spc/planSeek/savePlanMatSkuTmp",
    method: "post",
    data
  });
}
